<template>
  <div class='app-pagination'>
    <div class='pagination-wrapper'>
      <div class='pagination-item' v-if="items.length > 3" @click="selectPage(1)" :class="{'disabled': activePage === 1}">
        <v-icon name="angle-double-left"></v-icon>
      </div>
      <div class='pagination-item'  @click="selectPage(activePage, 'prev')" :class="{'disabled': activePage === 1}">
        <v-icon name="angle-left"></v-icon>
      </div>
      <div v-for="item of visibleItems" :key='item.content' class='pagination-item' :class="{'active': item.content === activePage}" @click='selectPage(item.content)'>
          {{item.content}}
      </div>
      <div class='pagination-item' @click="selectPage(activePage, 'next')" :class="{'disabled': activePage === count}">
        <v-icon name="angle-right"></v-icon>
      </div>
      <div class='pagination-item' v-if="items.length > 3" @click="selectPage(count)" :class="{'disabled': activePage === count}">
        <v-icon name="angle-double-right"></v-icon>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      items: [],
      visibleItems: [],
      activePage: 1
    }
  },
  name: 'AppPagination',
  props: {
    count: Number,
    onChangePage: Function
  },
  methods: {
    renderItems () {
      this.items = []
      for (let i = 1; i <= this.count; i++) {
        const item = { content: i }
        this.items.push(item)
      }
      this.selectPage(1)
    },
    selectPage (page, direction) {
      if (direction === 'prev' && this.activePage !== 1) {
        this.activePage = --page
      } else if (direction === 'next') {
        this.activePage = ++page
      } else {
        this.activePage = page
      }
      this.visibleItems = []
      if (this.activePage === 1) {
        this.items.forEach((item) => {
          if (item.content <= this.activePage + 2) {
            this.visibleItems.push(item)
          }
        })
      } else if (this.activePage === this.count) {
        this.items.forEach((item) => {
          if (item.content >= this.activePage - 2) {
            this.visibleItems.push(item)
          }
        })
      } else {
        this.items.forEach((item) => {
          if (
            item.content === this.activePage - 1 ||
            item.content === this.activePage + 1 ||
            item.content === this.activePage
          ) {
            this.visibleItems.push(item)
          }
        })
      }
      this.onChangePage(page)
    }
  },
  watch: {
    count (value) {
      this.renderItems()
    }
  },
  mounted () {
    this.renderItems()
  }
}
</script>
<style lang='scss' scoped>
@import 'src/styles/_colors.scss';
@import 'src/styles/_sizes.scss';
.app-pagination {
    display: flex;
    user-select: none;
    .pagination-wrapper {
        display: flex;
        flex-wrap: wrap;
        .pagination-item {
          height: 32px;
          width: 32px;
          border: 1px solid $primary-color;
          color: $primary-color;
          border-right: 0;
          display: flex;
          font-size: 14px;
          align-items: center;
          justify-content: center;
          transition: all 0.15s ease-in-out;
          cursor: pointer;
          &:hover {
              background-color: $primary-color;
              color: $white-color;
          }
          &.active {
              background-color: $primary-color;
              color: $white-color;
          }
          &.disabled {
            opacity: 0.5;
            pointer-events: none;
          }
          &:first-child {
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
          }
          &:last-child {
              border-top-right-radius: 5px;
              border-bottom-right-radius: 5px;
              border-right: 1px solid $primary-color;
          }
        }
    }
}
</style>
